import { reducers } from 'redux/core'
import request from 'sb-request'

import perfumeCaseOfMonthQuery from './perfumeCaseOfMonthQuery.graphql'
import setUpchargeForPerfumeCaseMutation from './setUpchargeForPerfumeCaseMutation.graphql'


const modifyResult = ({ currentMonth, ...rest } = {}) => ({
  ...rest,
  ...(currentMonth || {}),
})

const fetch = () => {
  reducers.view.caseMonthlyDesignPage.setFetching(true)

  request.post('graphql?name=perfumeCaseOfMonth', {
    body: {
      query: perfumeCaseOfMonthQuery,
    },
    modifyResult: ({ perfumeCaseOfMonth }) => modifyResult(perfumeCaseOfMonth),
  })
    .then(
      (response) => reducers.view.caseMonthlyDesignPage.setData(response),
      () => reducers.view.caseMonthlyDesignPage.setFetching(false)
    )
}

const setSelectedStatus = ({ enabled, page }) => (
  request.post('graphql?name=setUpchargeForPerfumeCase', {
    body: {
      query: setUpchargeForPerfumeCaseMutation,
      variables: {
        enabled,
        page,
      },
    },
    modifyResult: ({ setUpchargeForPerfumeCase }) => modifyResult(setUpchargeForPerfumeCase),
  })
    .then((response) => {
      reducers.view.caseMonthlyDesignPage.setData(response)

      return response
    })
)

// eslint-disable-next-line prefer-destructuring
const reset = reducers.view.caseMonthlyDesignPage.reset

export default {
  fetch,
  reset,
  setSelectedStatus,
}
